import HeroView from '@/components/home/hero';
import NextEditionView from '@/components/home/next-edition';
import OutrosEncontrosView from '@/components/home/outros-encontros';
import PreviousBooksCarouselView from '@/components/home/reading-showcase/PreviousBooksCarouselView';
import ReadingShowcaseView from '@/components/home/reading-showcase/ReadingShowcaseView';

const HomePage = () => {
  return (
    <div className="bg-background text-on-surface selection:bg-primary-fixed selection:text-on-primary-fixed min-h-screen">
      <main className="w-full relative z-10 mx-auto md:px-margin-desktop px-margin-mobile pb-32">
        <HeroView />
        <NextEditionView />
        <OutrosEncontrosView />
        <ReadingShowcaseView />
        <PreviousBooksCarouselView />
        {/* <GaleriaLidosView /> */}
      </main>
    </div>
  );
};

export default HomePage;
